import service from "@irati/utils/tracking"

const viewRewards = () => {
  service.trackRecognitionEvent("recognition_view_reward")
}

const viewRecognition = () => {
  service.trackRecognitionEvent("recognition_view_recognition")
}

const viewSummary = () => {
  service.trackRecognitionEvent("recognition_view_summary")
}

const viewProfile = () => {
  service.trackRecognitionEvent("recognition_view_profile")
}

const clickMyCelebrations = (data: any) => {
  service.trackRecognitionEvent("celebrations_click_my_celebrations", data)
}

const giveRewardsPoints = () => {
  service.trackCTAEvent({
    source: "rp_widget_manager",
    type: "give_reward_points"
  })
}

const openRewardWallet = () => {
  service.trackCTAEvent({
    source: "rp_widget_manager",
    type: "open_reward_wallet"
  })
}

const viewRewardCatalog = () => {
  service.trackCTAEvent({
    source: "rp_widget_user",
    type: "browse_reward_catalog"
  })
}

export default {
  viewProfile,
  viewRewards,
  viewSummary,
  viewRecognition,
  openRewardWallet,
  viewRewardCatalog,
  giveRewardsPoints,
  clickMyCelebrations
}
